/* eslint-disable @typescript-eslint/naming-convention */
/* default verb for Create button, if there is no config, it will be used with model name e.g.: "Create Project" */
export const DEFAULT_CREATE_BUTTON_TITLE_VERB = 'Create';

export const DEFAULT_CREATE_BUTTON_ICON = 'far fa-add';
